module.exports = __webpack_public_path__ + "img/CheckBox.615ac3de.svg";